/* eslint-disable import/prefer-default-export */
import Immutable from 'immutable';
import { createSelector } from 'reselect';

const getFormatsData = state => state.getIn(['bibs', 'digitalFormats'], Immutable.Map());

export const selectAllDigitalFormats = createSelector([getFormatsData], formatsData =>
  formatsData.map(data => data.get('formats', Immutable.List()))
);
